const buttonSize = {
  extraLarge: 60,
  large: 50,
  medium: 40,
  small: 30,
  extraSmall: 24,
};

const iconSize = {
  extraLarge: 36,
  large: 30,
  medium: 24,
  small: 18,
  extraSmall: 16,
};

export { buttonSize, iconSize };



// WEBPACK FOOTER //
// ./packages/marvel-ui-button/sizes.spec.js